export const ACCESS_TOKEN_KEY = 'GG-Portal-AccessToken';
export const REFRESH_TOKEN_KEY = 'GG-Portal-RefreshToken';
